import { Component } from '@angular/core';

interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  children?: MenuItem[];
  expanded?: boolean;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  collapsed = false;

  menuItems: MenuItem[] = [
    { label: 'Dashboard', icon: 'LayoutDashboard', route: '/dashboard' },
    {
      label: 'Master Data', icon: 'Database',
      expanded: false,
      children: [
        { label: 'Company Industry', icon: 'Building2', route: '/master-data/company-industry' }
      ]
    },
    { label: 'Office', icon: 'Building', route: '/office' },
    { label: 'Client Management', icon: 'Users', route: '/client' },
    { label: 'Employee Management', icon: 'UserCircle', route: '/employee' },
    { label: 'Attendance', icon: 'Clock', route: '/attendance' },
    { label: 'Leave Management', icon: 'CalendarOff', route: '/leave' },
    { label: 'Timesheet', icon: 'ClipboardList', route: '/timesheet' },
    { label: 'Reporting', icon: 'BarChart3', route: '/reporting' }
  ];

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
  }

  toggleSubmenu(item: MenuItem): void {
    if (item.children) {
      item.expanded = !item.expanded;
    }
  }
}
